// Composable for global modal management
import { shallowRef, readonly, markRaw, type Component } from "vue";

interface ModalOptions {
    modalKey?: string;
    hideClose?: boolean;
    props?: Record<string, unknown>;
    modalClass?: string;
    on?: Record<string, (...args: any[]) => void>;
}

interface ModalState {
    isOpen: boolean;
    component: Component | null;
    modalKey: string;
    hideClose: boolean;
    modalClass?: string;
    props: Record<string, unknown>;
    events: Record<string, (...args: any[]) => void>;
}

const modals = shallowRef<ModalState[]>([]);

export function useGlobalModal() {
    const showGlobalModal = (component: Component, options: ModalOptions = {}) => {
        const modalKey = options.modalKey || Date.now().toString();

        modals.value = [
            ...modals.value,
            {
                isOpen: true,
                component: markRaw(component),
                modalKey,
                hideClose: options.hideClose || false,
                props: options.props || {},
                modalClass: options.modalClass,
                events: options.on || {},
            },
        ];

        return modalKey;
    };

    const hideGlobalModal = (key?: string) => {
        if (key) {
            modals.value = modals.value.filter((m) => m.modalKey !== key);
        } else {
            modals.value = modals.value.slice(0, -1);
        }
    };

    const hideAllModals = () => {
        modals.value = [];
    };

    return {
        modals: readonly(modals),
        showGlobalModal,
        hideGlobalModal,
        hideAllModals,
    };
}
